<template>
  <div>
    <div v-if="loading" class="row">
      <div class="col-12">
        <div class="text-center text-primary my-2">
          <b-spinner type="grow" class="align-middle"></b-spinner>
        </div>
      </div>
    </div>
    <div v-else-if="oneAnswer && loadData" class="row">
      <div class="col-lg-4">
        <div class="bg-timeline">
          <div class="timeline-header text-center">
            <span class="timeline-title">
              {{ $t('answers.answersDetails.historic') }}
              {{ getFirstName(oneAnswer.anonymousResponse, oneAnswer.name) }}
            </span>
            <hr />
          </div>
          <div class="timeline-body">

            <div class="text-center" v-if="isRiachuelo">
              <b-button @click="setCostumerTimeline">Carregar histórico</b-button>
            </div>

            <light-timeline :items="items">
              <template slot="content" slot-scope="{ item }">
                <div>
                  <p class="font-weight-bold m-0">
                    {{ $t('answers.answersDetails.note') }}:
                    {{
                      !oneAnswer.anonymousResponse
                        ? item.content.review === 99
                          ? '-'
                          : item.content.review
                        : '**********'
                    }}
                  </p>
                  <p class="m-0">
                    {{ $t('answers.answersDetails.channel') }}:
                    {{
                      !oneAnswer.anonymousResponse
                        ? item.content.channel
                        : '***********'
                    }}
                  </p>
                  <p class="m-0">
                    {{ $t('answers.answersDetails.action') }}:
                    <template v-if="!oneAnswer.anonymousResponse">
                      {{ item.content.action ? item.content.action.name : '-' }}
                    </template>
                    <template v-else>***********</template>
                  </p>
                  <p class="m-0">
                    {{ $t('answers.answersDetails.comment') }}:
                    <template v-if="!oneAnswer.anonymousResponse">
                      {{ item.content.feedback ? item.content.feedback : '-' }}
                    </template>
                    <template v-else>***********</template>
                  </p>
                  <p class="m-0">
                    {{ item.content.branch ? item.content.branch : '' }}
                  </p>
                  <template v-if="!oneAnswer.anonymousResponse">
                    <a target="_blank" :href="item.content.answerId">
                      <i class="fas fa-search"></i>
                      Visualizar Pesquisa
                    </a>
                  </template>
                </div>
              </template>
            </light-timeline>
          </div>
        </div>
      </div>
      <div class="col-lg-8" style="padding: 0 20px;">
        <div class="row mt-4">
          <div class="col-lg-2 text-center">
            <template v-if="oneAnswer.metric === 'like-dislike'">
              <h4>{{ $t('answers.ratingAnswer') }}</h4>
              <span v-if="oneAnswer.review === 1">
                <img
                  alt="Like"
                  width="60"
                  height="60"
                  src="../../../../../assets/Like.svg"
                />
              </span>
              <span v-if="oneAnswer.review === 0">
                <img
                  alt="Deslike"
                  width="60"
                  height="60"
                  class="thumbs-down-answer"
                  src="../../../../../assets/Deslike.svg"
                />
              </span>
            </template>
            <template v-else>
              <h4>{{ $t('answers.answersDetails.note') }}</h4>
              <div
                :class="`mt-3 flag-grade flag-grade-${gradeFormat(
                  oneAnswer.review,
                )}`"
              >
                {{ oneAnswer.review === 99 ? '-' : oneAnswer.review }}
              </div>
            </template>
          </div>
          <div class="col-lg-10 align-self-end">
            <span class="user-info">
              {{ checkName(oneAnswer.anonymousResponse, oneAnswer.name) }}
            </span>
            <br />
            <span class="user-info"> Canal: {{ oneAnswer.channel }} </span>
            <br />
            <span class="user-info">
              {{ $t('answers.answersDetails.email') }}:
              {{
                checkUserData(
                  oneAnswer.anonymousResponse,
                  userProfile.permissions.answers.anonymous_profile,
                  oneAnswer.email,
                )
              }}
            </span>
            <br />
            <span class="user-info">
              {{ $t('answers.answersDetails.phone') }}:
              {{
                checkUserData(
                  oneAnswer.anonymousResponse,
                  userProfile.permissions.answers.anonymous_profile,
                  oneAnswer.phone,
                )
              }}
            </span>
            <br />
            <span class="user-info">
              {{ $t('answers.answersDetails.date') }}:
              {{ dateFormat(oneAnswer.date) }}
            </span>
            <br />
            <span class="user-info">
              ControlId: {{ oneAnswer.controlId }}
            </span>
          </div>
        </div>
        <div class="row mt-5" style="height: auto;">
          <div class="col-12">
            <h4>{{ $t('answers.answersDetails.comment') }}</h4>
            <div class="text-left" v-if="!oneAnswer.anonymousResponse && oneAnswer.audioResponseUrl">
              <audio :src="oneAnswer.audioResponseUrl" controls style="height: 30px;"></audio>
            </div>
            <hr />
            <p>
              {{ (oneAnswer.translatedFeedback) ? oneAnswer.translatedFeedback : convertText(oneAnswer) }}
            </p>
              <div class="translate" v-if="oneAnswer.feedback && company.enableTranslateFeedback">
                <img id="popover-reactive-1" src="../../../../../assets/translate.png" width="20px" alt="">
              </div>
              <b-popover
                target="popover-reactive-1"
                triggers="hover"
                placement="auto"
                container="my-container"
                ref="popover"
              >
                <template #title>
                  Traduzir para:
                </template>
                  <div>
                    <b-spinner
                    style="position: absolute; top:10px; right: 8px;"
                    v-if="isLoadingTranslate"
                    small
                    class="pull-right"
                    variant="primary"
                  ></b-spinner>
                    <div v-for="item in translations" class="translate-list-item"
                      @click="translate(oneAnswer.feedback, item.target)">
                      {{ item.label }}
                    </div>
                  </div>
              </b-popover>
            <!--
            <p>
              {{
                oneAnswer.feedbackEdited.edition
                  ? oneAnswer.feedbackEdited.edition
                  : oneAnswer.feedback
              }}
            </p>
            -->
          </div>
        </div>
        <div v-if="!oneAnswer.anonymousResponse && oneAnswer.audioResponseUrls" class="mt-3 mr-2">
          <div class="audio" v-if="Array.isArray(oneAnswer.audioResponseUrls)">

            <div v-for="(item, index) in oneAnswer.audioResponseUrls" :key="index">
              <b-button size="sm" variant="link" @click="currentAudioSrc = item">Audio {{ index + 1 }}</b-button>
            </div>
          </div>

          <div v-else>
            <b-button  size="sm" variant="link" @click="currentAudioSrc = oneAnswer.audioResponseUrls">Audio 1</b-button>
          </div>

          <div v-if="currentAudioSrc" class="mt-3">
            <audio  :src="currentAudioSrc" controls style="height: 30px;"></audio>
          </div>
        </div>
        <div
          v-if="
            oneAnswer.sentimentAnalyzeGCP &&
            (oneAnswer.feedback !== '' || oneAnswer.feedbackEdited.edition)
          "
          class="row mt-5"
        >
          <div class="col-12">
            <span class="size-sentiment-analyze">{{
              $t('answers.answersDetails.sentimentAnalyze')
            }}</span>
            <span id="popover-target-1">
              <font-awesome-icon
                :icon="['fas', 'info-circle']"
                style="font-size: 15px; color: #c1c1c1;"
              />
            </span>

            <b-popover
              target="popover-target-1"
              triggers="hover"
              placement="top"
            >
              <span>{{ $t('answers.answersDetails.sentimentMsg') }}</span>
            </b-popover>
            <hr />
          </div>
          <div class="col-12 flexdisplay">
            <div class="col-4">
              <div class="col-12 mb-3">
                <strong>{{ $t('answers.answersDetails.sentiment') }}</strong>
              </div>

              <table class="stable">
                <tr>
                  <td style="width: 30%;">
                    <img
                      :src="
                        require(`../../../../../assets/${getSentiment(
                          oneAnswer.sentimentAnalyzeGCP.score,
                        )}.gif`)
                      "
                    />
                    <div style="padding-top: 10px;">
                      <strong>
                        {{ formatScore(oneAnswer.sentimentAnalyzeGCP.score) }}
                      </strong>
                    </div>
                  </td>
                  <td style="width: 5%;">
                    <span style="font-size: 30px;"> = </span>
                  </td>
                  <td style="width: 65%;">
                    <span
                      :class="`flag-sentiment flag-sentiment-${getSentiment(
                        oneAnswer.sentimentAnalyzeGCP.score,
                      )}`"
                    >
                      {{ formatSentiment(oneAnswer.sentimentAnalyzeGCP.score) }}
                    </span>
                  </td>
                </tr>
              </table>
              <!--
              <div class="col-12 flexdisplay">
                <div class="col-5 text-center">
                  <div class="col-12">
                    <img
                      :src="
                        require(`../../../../../assets/${getSentiment(
                          oneAnswer.sentimentAnalyzeGCP.score,
                        )}.gif`)
                      "
                    />
                  </div>
                  <div class="col-12" style="padding-top: 10px;">
                    <strong>
                      {{ oneAnswer.sentimentAnalyzeGCP.score.toFixed(1) }}
                    </strong>
                  </div>
                </div>

                <div class="col-7 text-center">
                  <span
                    :class="`flag-sentiment flag-sentiment-${getSentiment(
                      oneAnswer.sentimentAnalyzeGCP.score,
                    )}`"
                  >
                    {{ formatSentiment(oneAnswer.sentimentAnalyzeGCP.score) }}
                  </span>
                </div>
              </div>
              -->
            </div>
            <div class="col-8">
              <div class="col-12 mb-3">
                <strong>{{ $t('answers.answersDetails.keywords') }}</strong>
              </div>
              <div
                class="chip"
                v-for="(item, index) in oneAnswer.sentimentAnalyzeGCP
                  .keyPhrases"
                :key="index"
              >
                <span> {{ item }} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <h4>{{ $t('answers.answersDetails.categories') }}</h4>
            <hr />

            <template v-if="userProfile.permissions.treatments.category">
              <div class="categories-area">
                <div
                  v-for="(category, i) in oneAnswer.categories"
                  :key="i"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <idx-chips :categoryIA="isCategoryIA(category._id)">
                    <span>{{ category.name }}</span>
                    <span
                      class="closebtn"
                      @click="handleRemoveCategory(category._id, i)"
                      >&times;</span
                    >
                  </idx-chips>

                  <template
                    v-for="(subCategory, index) in oneAnswer.subCategories"
                  >
                    <idx-chips
                      v-if="subCategory.mainCategoryId === category._id"
                      :key="index"
                      :subCategory="true"
                      style="margin-left: 24px;"
                    >
                      <span>{{ subCategory.name }}</span>
                      <span
                        class="closebtn"
                        @click="
                          handleRemoveSubCategory(
                            category._id,
                            subCategory._id,
                            index,
                          )
                        "
                        >&times;</span
                      >
                    </idx-chips>
                  </template>
                </div>
              </div>

              <span>
                <dropdown-categories
                  :id-item="`${oneAnswer._id}`"
                  :categories="oneAnswer.categories"
                  :categoryGroupId="oneAnswer.actionId.categoryGroupId"
                  :myAnswer="oneAnswer"
                  :subCategory="oneAnswer.subCategories"
                />
              </span>
            </template>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <h4>{{ $t('answers.answersDetails.indicators') }}</h4>
            <hr />
            <div class="indicators">
              <div v-if="oneAnswer.indicators.length === 0">
                <span style="font-style: italic;">{{
                  $t('answers.answersDetails.none')
                }}</span>
              </div>
              <div v-for="(indicator, i) in oneAnswer.indicators" :key="i">
                <div ref="chip" class="chip">
                  {{
                    indicatorAnonymous(
                      oneAnswer.actionId,
                      oneAnswer.anonymousResponse,
                      indicator.column,
                      indicator.value,
                      indicator.indicatorId,
                    )
                  }}

                  <!-- {{ indicator }} -->

                  <!-- <span>
                    {{ indicator.column }}:
                    {{ !oneAnswer.anonymousResponse ? indicator.value : '**' }}
                  </span>  -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <h4>
              {{ $t('answers.answersDetails.additionalQuestions') }}
            </h4>
            <hr />
          </div>
        </div>
        <div class="row">
          <div
            class="col-12"
            v-for="(item, i) in oneAnswer.additionalQuestions"
            :key="i"
          >
            <template
              v-if="
                indicatorValuedQuestion(item) &&
                (!item.conditionalQuestion || !item.conditionalQuestion.length ||
                  item.conditionalQuestion.includes(conditionalQuestion()))
              "
            >
              <like-dislike
                v-if="item.type === 'LIKE/DISLIKE'"
                :questionText="item.text"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :itemId="i.toString()"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <emotion
                v-if="item.type === 'EMOTION'"
                :questionText="item.text"
                :index="i"
                :justView="true"
                :itemId="i.toString()"
                :selected="parseInt(item.review)"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <likert
                v-if="item.type === 'LIKERT'"
                :text="item.text"
                :itemId="i.toString()"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
                :template="returnTypeTemplate(item.questionId, oneAnswer.actionId.email.additionalQuestions)"
              />

              <reviews
                v-if="item.type === 'REVIEWS'"
                :text="item.text"
                :item-id="i.toString()"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <csat
                v-if="item.type === 'CSAT'"
                :text="item.text"
                :item-id="i.toString()"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :colorTemplate="oneAnswer.actionId.email.template.scale"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <multiple-choices
                v-if="item.type === 'MULTIPLE' && item.multipleValues && item.multipleValues.length > 0"
                :type="item.multipleType || ''"
                :questionText="item.text"
                :choices="item.multipleValues"
                :justView="true"
                :hasComment="item.comment"
                :idQuestion="item._id"
                :itemId="i.toString()"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <multipleChoicesCustom
                v-if="item.type === 'MULTIPLE' && item.options && item.options.length > 0"
                :type="item.multipleType || ''"
                :questionText="item.text"
                :choices="item.options"
                :justView="true"
                :hasComment="item.comment"
                :idQuestion="item._id"
                :itemId="i.toString()"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <ces
                v-if="item.type === 'CES'"
                :text="item.text"
                :item-id="i.toString()"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :colorTemplate="oneAnswer.actionId.email.template.scale"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <input-type
                v-if="item.type === 'INPUT'"
                :text="item.text"
                :answerText="item.anonymousResponse && oneAnswer.anonymousResponse
                || userProfile.permissions.answers.anonymous_profile ?
                '******' : item.answerText"
                :index="i"
                :justView="true"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <label-question
                v-if="item.type === 'LABEL'"
                :text="item.text"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <nps
                v-if="item.type === 'NPS'"
                :text="item.text"
                :item-id="i.toString()"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :colorTemplate="oneAnswer.actionId.email.template.scale"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />

              <likertEmotion
                v-if="item.type === 'LIKERT/EMOTION'"
                :text="item.text"
                :item-id="i.toString()"
                :index="i"
                :justView="true"
                :selected="parseInt(item.review)"
                :colorTemplate="oneAnswer.actionId.email.template.scale"
                :hasComment="item.comment"
                :reviewAnswer="item.review ? item.review : -99"
                :idQuestion="item._id"
                :addQuestionTemplate="item.addQuestionTemplate"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import idxChips from '@/components/molecules/idx-chips';
import dropdownCategories from '@/components/molecules/dropdown-categories';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import likert from '@/components/molecules/metrics/likert';
import reviews from '@/components/molecules/metrics/reviews';
import csat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import multipleChoicesCustom from '@/components/molecules/metrics/multiple-choices-custom';
import inputType from '@/components/molecules/metrics/input-type';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import labelQuestion from '@/components/molecules/metrics/label-question';
import api from '../../../../../services/api';

export default {
  components: {
    idxChips,
    dropdownCategories,
    likeDislike,
    emotion,
    likert,
    reviews,
    csat,
    nps,
    multipleChoices,
    multipleChoicesCustom,
    inputType,
    labelQuestion,
    ces,
    likertEmotion,
  },

  props: {
    item: { type: Array },
  },

  data: () => ({
    loading: false,
    loadData: false,
    userAuth: null,
    options: [],
    items: [],
    actionCategories: [],
    actionSubCategories: [],
    addQuestions: [],
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    ih1Value: null,
    indicatorsAction: [],
    isRiachuelo: false,
    isLoadingTranslate: false,
    translations: [
    {label: 'Portuguese', target: 'pt'},
    {label: 'English', target: 'en'},
    {label: 'Spanish', target: 'es'},
    {label: 'French', target: 'fr'},
    {label: 'German', target: 'de'}
    ],
    currentAudioSrc: null,
  }),

  computed: {
    ...mapState('treatments', ['oneAnswer']),
    // ...mapState('settings', ['companyCategories']),
    ...mapState('companies', ['myMetric', 'company']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('authentication', ['userProfile']),
    ...mapFields('branches', ['ih1', 'myHierarchies1', 'myHierarchies2']),
  },

  watch: {
    myIh1: function watchIh1() {
      this.setCostumerTimeline();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.setCostumerTimeline();
    },

    myIh2: function watchIh2() {
      this.setCostumerTimeline();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.setCostumerTimeline();
    },
  },

  methods: {
    ...mapActions('treatments', ['deleteCategory', 'setCostumerNotifications']),
    ...mapActions('settings', ['getCategories']),

    async translate(feedback, target){

      if(feedback){
        this.isLoadingTranslate = true;
        const response = await api.get(
          `/translate?text=${feedback}&target=${target}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            }
          },
        );

        this.isLoadingTranslate = false;

        if(response && response.data && response.data.translatedText){
          this.oneAnswer.translatedFeedback = response.data.translatedText
        }

      }

    },

    returnTypeTemplate(idQuestion, questionsConfiguredInAction){
      for(let i = 0; i < questionsConfiguredInAction.length; i+=1){
        if(questionsConfiguredInAction[i].questionId === idQuestion){
          return questionsConfiguredInAction[i].template;
        }
      }

      return 'satisfaction';
    },

    async getIndicators() {
      const indicators = await api.get(
        `/indicator/${this.oneAnswer.actionId._id}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            answerForm: true,
          },
        },
      );

      this.indicatorsAction = indicators.data;
    },

    convertText(oneAnswer) {
      const myText = oneAnswer.feedbackEdited.edition
        ? oneAnswer.feedbackEdited.edition
        : oneAnswer.feedback;
      return myText;
    },

    indicatorAnonymous(actionId, anonymous, column, indicator, indicatorId) {
      let anonymousIndicator = false;
      this.indicatorsAction.forEach((el) => {
        if (el.actionId === actionId._id && el._id === indicatorId) {
          if (el.anonymous) {
            anonymousIndicator = true;
          } else {
            anonymousIndicator = false;
          }
          for (let idx = 0; idx < el.types.length; idx += 1) {
            if (el.types[idx] === 'anonymous' || el.types[idx] === 'clientId') {
              anonymousIndicator = true;
              break;
            }
          }
        }
        // return `${column}: ${indicator}`;
      });
      if (
        anonymous ||
        this.userProfile.permissions.answers.anonymous_profile ||
        anonymousIndicator
      ) {
        if (this.oneAnswer.ih1) {
          this.branches.branches.forEach((el) => {
            if (el._id === this.oneAnswer.ih1) {
              this.ih1Value = el.corporate_name;
            }
          });

          // in anonymous case it returns only the value of ih1
          if (indicator === this.ih1Value) {
            return `${column}: ${this.ih1Value}`;
          }
        }
        if (anonymous && anonymousIndicator) {
          return `${column}: **`;
        }

        if (anonymousIndicator && this.userProfile.permissions.answers.anonymous_profile) {
          return `${column}: **`;
        }

        return `${column}: ${indicator}`;
      } else if (indicator) {
        return `${column}: ${indicator}`;
      }
      return `${column}: ${indicator}`;
    },

    conditionalQuestion() {
      if (this.promotersGrades.includes(this.oneAnswer.review)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.oneAnswer.review)) {
        return 'detrator';
      }

      return 'neutro';
    },

    async setCostumerTimeline() {
      this.loading = true;
      if (this.$route.params.id) {
        const response = await api.get(
          `/treatments/timeline/${this.$route.params.id}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
              clientId: this.oneAnswer.clientId,
              email: this.oneAnswer.email,
              phone: this.oneAnswer.phone,
            },
          },
        );

        this.items = [];

        response.data.forEach((el) => {
          if (!el.anonymousResponse) {
            this.items.push({
              tag: !this.oneAnswer.anonymousResponse
                ? this.dateFormat(el.date)
                : '*******',
              content: el,
              type: 'circle',
              color: this.getColor(el.review, el.metric),
            });
          }
        });
      }

      this.loading = false;
    },

    checkName(anonymous, name) {
      if (
        anonymous &&
        !this.userProfile.permissions.answers.anonymous_profile
      ) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem nome';
    },

    checkUserData(anonymous, profile, value) {
      if (anonymous || profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    dateFormat(param) {
      if (param) {
        const day = lightFormat(new Date(param), 'dd/MM/yyyy');
        const hour = lightFormat(new Date(param), 'HH:mm');
        return `${day} às ${hour}`;
      }

      return null;
    },

    gradeFormat(grade) {
      if (this.oneAnswer.metric === 'nps-0-10' || this.oneAnswer.metric === 'csat-0-10(media)') {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }

        return 'invalid';
      } else if (this.oneAnswer.metric.indexOf('1-5') > -1) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.oneAnswer.metric.indexOf('stars') > -1) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.oneAnswer.metric === 'like-dislike') {
        if (grade === 1) {
          return 'promoters';
        } else if (grade === 0) {
          return 'detractors';
        }
        return 'invalid';
      }

      return 'invalid';
    },

    getFirstName(isAnonymous, fullName) {
      if (this.userProfile.permissions.answers.menu) {
        if (
          isAnonymous &&
          !this.userProfile.permissions.answers.anonymous_profile
        ) {
          return 'Anônimo';
        } else if (this.userProfile.permissions.answers.anonymous_profile) {
          return '**************';
        } else if (fullName) {
          let firstName = '';

          for (let i = 0; i < fullName.length; i += 1) {
            if (fullName[i] !== ' ') {
              firstName += fullName[i];
            } else {
              return firstName;
            }
          }
          return firstName;
        }
        return '';
      }
      return '';
    },

    getColor(review, metric) {
      if (metric === 'nps-0-10') {
        if (review > 8) {
          return 'green';
        } else if (review === 7 || review === 8) {
          return 'yellow';
        }
        return 'red';
      } else if (metric && metric.includes('5')) {
        if (review > 3) {
          return 'green';
        } else if (review === 3) {
          return 'yellow';
        }
        return 'red';
      } else if (metric && metric.includes('like')) {
        if (review === 1) {
          return 'green';
        } else if (review === 0) {
          return 'red';
        }
        return 'green';
      }

      return null;
    },

    async deleteCategoryByX(categoryId) {
      this.oneAnswer.categories.splice(
        this.oneAnswer.categories.indexOf(categoryId),
        1,
      );
      try {
        await api.patch(
          `/answer-categories/${this.oneAnswer._id}`,
          {
            operation: 'delete',
            categoryId,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } catch (error) {
        window.console.log(error);
      }
    },

    getSentiment(score) {
      let sentiment = '';
      if (score < 0) {
        sentiment = 'negative';
      } else if (score >= 0.6) {
        sentiment = 'positive';
      } else {
        sentiment = 'neutral';
      }
      return sentiment;
    },

    formatSentiment(score) {
      let label = '';
      if (score < 0) {
        label = this.$t('answers.answersDetails.negative');
      } else if (score >= 0.6) {
        label = this.$t('answers.answersDetails.positive');
      } else {
        label = this.$t('answers.answersDetails.neutral');
      }
      return label;
    },

    formatScore(score) {
      let myScore = (score * 100).toFixed(0);
      if (score >= 0) {
        myScore = `+${myScore}`;
      }
      return myScore;
    },

    async getActionCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            categoryGroup: this.oneAnswer.actionId.categoryGroupId,
          },
        });
        this.actionCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    getCategoryName(id) {
      for (let i = 0; i < this.actionCategories.length; i += 1) {
        if (id === this.actionCategories[i]._id) {
          return this.actionCategories[i].name;
        }
      }
      return '';
    },

    async getActionSubCategories() {
      try {
        const response = await api.get('/all-subcategories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        this.actionSubCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    getSubCategoryName(idCategory, idSubCategory) {
      if (idCategory) {
        idCategory = idCategory.substr(0, idCategory.length - 1);
      }

      for (let i = 0; i < this.actionSubCategories.length; i += 1) {
        if (idSubCategory === this.actionSubCategories[i]._id) {
          for (let j = 0; j < this.actionCategories.length; j += 1) {
            if (idCategory === this.actionCategories[j]._id) {
              return `${this.actionCategories[j].name}-${this.actionSubCategories[i].name}`;
            }
          }
        }
      }
      return '';
    },

    isCategoryIA(id) {
      if (this.oneAnswer.categoriesIA) {
        for (let i = 0; i < this.oneAnswer.categoriesIA.length; i += 1) {
          if (id === this.oneAnswer.categoriesIA[i]) {
            return true;
          }
        }
      }
      return false;
    },

    async handleRemoveCategory(categoryId, categoryIndex) {
      swal({
        title: this.$t('answers.deleteCategory.title'),
        text: this.$t('answers.deleteCategory.description'),
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then(async (deleted) => {
        if (deleted) {
          swal(this.$t('answers.categoryDelSuccess'), {
            icon: 'success',
          });
          this.oneAnswer.categories.splice(categoryIndex, 1);
          const subCategories = [];
          this.oneAnswer.subCategories.forEach((el) => {
            if (el.mainCategoryId !== categoryId) {
              subCategories.push(el);
            }
          });
          this.oneAnswer.subCategories = subCategories;
          await api.patch(
            `/answer-categories/${this.oneAnswer._id}`,
            {
              operation: 'delete',
              categoryId,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
        }
      });
    },

    async handleRemoveSubCategory(categoryId, subCategoryId, subCategoryIndex) {
      this.oneAnswer.subCategories.splice(subCategoryIndex, 1);

      await api.patch(
        `/category-subcategory/${this.oneAnswer._id}`,
        {
          subCategoryId,
          categoryId,
          operation: 'delete',
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.oneAnswer.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              item.selectedIndicator &&
              this.oneAnswer.indicators[i] && this.oneAnswer.indicators[i].column && this.oneAnswer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                item.indicatorValue &&
                this.oneAnswer.indicators[i] && this.oneAnswer.indicators[i].value && this.oneAnswer.indicators[i].value.toLowerCase() ===
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              item.selectedIndicator &&
              this.oneAnswer.indicators[i] && this.oneAnswer.indicators[i].column && this.oneAnswer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                item.indicatorValue &&
                this.oneAnswer.indicators[i] && this.oneAnswer.indicators[i].value && this.oneAnswer.indicators[i].value.toLowerCase() !==
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              item.selectedIndicator && this.oneAnswer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.oneAnswer.indicators[i].value && this.oneAnswer.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // remove accents
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },

    async getAllBranches() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

      const response = await api.get(
        `treatments/branches/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      this.branches = response.data;
    },
  },

  created() {
    if (this.oneAnswer.metric.includes('0-10')) {
      this.promotersGrades = [10, 9];
      this.passivesGrades = [8, 7];
      this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
    }

    if (this.oneAnswer.metric === 'like-dislike') {
      this.promotersGrades = [1];
      this.detractorsGrades = [0];
    }
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.isRiachuelo = this.userAuth.companyId === '608847fadef1b07e809ad539' ? true : false;

    await this.getAllBranches();

    if(!this.isRiachuelo){
      await this.setCostumerTimeline();
    }

    await this.getActionCategories();

    await this.getActionSubCategories();

    await this.getIndicators();

    this.loadData = true;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.audio {
  display: flex;
  gap: 10px;
}

.categories-area {
  max-height: 150px;
  overflow: auto;
}

h4 {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 100;
}

.chip {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: #000;
  border: 1px solid #000;
  color: $white;
  display: flex;
  align-items: center;
}

.closebtn {
  padding-left: 10px;
  color: $white;
  font-weight: bold;
  float: right;
  font-size: 15px;
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}

.timeline-title {
  color: #606c76;
  text-transform: uppercase;
  font-weight: 100;
  font-size: 18px;
}

.bg-timeline {
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 10px;
}

.timeline-body {
  overflow: auto;
  max-height: 500px;
  min-height: 500px;
}

.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  color: $white;
  font-weight: bold;
  font-size: 28px;
  margin-left: auto;
  margin-right: auto;
}

.size-sentiment-analyze {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 100;
}

.flag-category-text {
  text-transform: lowercase;
}

.flag-category-close {
  cursor: pointer;
}

.flag-grade-promoters {
  background-color: #28a745;
}

.flag-grade-detractors {
  background-color: #dc3545;
}

.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}

.flag-grade-invalid {
  background-color: #c1c1c1;
}

.user-info {
  color: rgb(133, 131, 131);
  font-style: italic;
}

.smile-icon {
  color: $primary;
  font-size: 28px;
  &:first-child {
    margin-right: 10px;
  }
}
.flexdisplay {
  display: flex;
}
.chips-area {
  display: flex;
  flex-direction: row;

  .chip {
    padding: 3px 15px;
    font-size: 16px;
    border-radius: 20px;
    margin: 2px;
    background-color: $gray;
    border: 1px solid $white;
    color: $white;
  }
}
.flag-sentiment {
  padding: 10px 40px;
  font-size: 20px;
  color: white;
  border-radius: 20px;
}
.flag-sentiment-negative {
  background-color: #dc3545;
}
.flag-sentiment-neutral {
  background-color: rgb(211, 211, 17);
}
.flag-sentiment-positive {
  background-color: #28a745;
}
.stable {
  width: 100%;
  text-align: center;
}
.ar-icon {
  margin-top: -10px;
}
textarea {
  resize: none;
  width: inherit;
}

.translate img{
  width: 20px;
  cursor: pointer;
}

.translate-list-item{
  border-bottom: solid 1px #f5f2f2;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
  min-width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/treatments/treatment-details/action-data/index.vue